import React from "react";
import { DraggableModal, FileField, IButton } from "../../../../ui-kit";
import dictionariesStore from "../../../../store/dictionary";
import { Col, Row } from "antd";
import { observer } from "mobx-react-lite";

const ImportModal: React.FC = observer(() => {
  const [file, setFile] = React.useState<File>(null);

  const getPosition = () => {
    return { x: window.innerWidth / 2 - 400, y: 0 };
  };

  const onHandleSubmit = () => {
    const formData = new FormData();
    formData.append("file", file);
    dictionariesStore.importDictionary(formData).then(() => {
      handleCancel();
    });
  };

  const resetForm = () => {
    setFile(null);
  };

  const handleCancel = () => {
    dictionariesStore.isImportModalVisible.setFalse();
    resetForm();
  };

  const fileSelected = (e: FileList) => {
    setFile(e[0]);
  };

  return (
    <DraggableModal
      defaultPosition={getPosition()}
      open={dictionariesStore.isImportModalVisible.value}
      title="Обновление справочника"
      width={800}
      footer={
        <IButton
          onClick={onHandleSubmit}
          disabled={dictionariesStore.isUpdating.value}
        >
          Обновить
        </IButton>
      }
      onCancel={handleCancel}
    >
      <form>
        <Row>
          <Col span={10}>
            <label>Название</label>
          </Col>
          <Col span={14}>{dictionariesStore.currentDictItem.title}</Col>
        </Row>
        <Row>
          <Col>
            <FileField
              label="Выберите файл"
              accept=".csv"
              onChange={fileSelected}
            />
            {file ? <div>{file.name}</div> : null}
          </Col>
        </Row>
      </form>
    </DraggableModal>
  );
});

export default ImportModal;
